import { Component, Input } from '@angular/core';

type Position =  'left' | 'right';

@Component({
    selector: 'ridango-ui-ticket-block',
    templateUrl: './ticket-block.component.html',
})
export class TicketBlockComponent {
    @Input() type = 'single';
    @Input() position: Position = 'left';
    @Input() noPadding = false;
}
